// import { useEffect, useState } from "react";
// import {
//   getDocs,
//   collection,
//   updateDoc,
//   doc,
//   deleteDoc,
// } from "firebase/firestore";
// import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
// import { db } from "../../firebase";
// import css from "./blogeditor.module.css";
// import ReactQuill from "react-quill";
// import "react-quill/dist/quill.snow.css";

// const BlogListEditor = () => {
//   const [articles, setArticles] = useState([]);
//   const [editingArticle, setEditingArticle] = useState(null);
//   const [newPhotoFile, setNewPhotoFile] = useState(null);

//   const objList = [
//     { name: "Заголовок", transliter: "zag" },
//     { name: "Перший опис", transliter: "chortDesc" },
//     { name: "SEO title", transliter: "seoTitle" },
//     { name: "SEO description", transliter: "seoDescription" },
//     { name: "ID відео", transliter: "videoId" },
//   ];

//   const fetchArticles = async () => {
//     const snapshot = await getDocs(collection(db, "blog"));
//     const docs = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
//     setArticles(docs);
//   };

//   useEffect(() => {
//     fetchArticles();
//   }, []);

//   const handleEdit = (article) => {
//     setEditingArticle({ ...article });
//     setNewPhotoFile(null);
//   };

//   const handleChange = (field, value) => {
//     setEditingArticle((prev) => ({ ...prev, [field]: value }));
//   };

//   const handleFileChange = (e) => {
//     setNewPhotoFile(e.target.files[0]);
//   };

//   const handleSave = async () => {
//     if (!editingArticle) return;

//     try {
//       let updatedArticle = { ...editingArticle };

//       if (updatedArticle.longDesc) {
//         updatedArticle.longDesc = updatedArticle.longDesc.replace(
//           /<p><br><\/p>/g,
//           '<div class="spacer"></div>'
//         );
//       }

//       if (newPhotoFile) {
//         const storage = getStorage();
//         const storageRef = ref(
//           storage,
//           `blog/${editingArticle.id}/${newPhotoFile.name}`
//         );
//         await uploadBytes(storageRef, newPhotoFile);
//         const downloadURL = await getDownloadURL(storageRef);
//         updatedArticle.photo = downloadURL;
//       }

//       const refDoc = doc(db, "blog", editingArticle.id);
//       await updateDoc(refDoc, updatedArticle);
//       setEditingArticle(null);
//       fetchArticles();
//     } catch (error) {
//       console.error("Помилка при оновленні статті:", error);
//     }
//   };

//   const handleDelete = async (id) => {
//     if (!window.confirm("Ви впевнені, що хочете видалити цю статтю?")) return;
//     await deleteDoc(doc(db, "blog", id));
//     fetchArticles();
//   };

//   return (
//     <div className={css.divForList}>
//       <h2>Редактор блогу</h2>

//       {articles.map((a) => (
//         <div key={a.id} className={css.listLiProd}>
//           <p>
//             <strong>{a.zag}</strong>
//           </p>
//           <button onClick={() => handleEdit(a)}>Редагувати</button>
//           <button onClick={() => handleDelete(a.id)}>Видалити</button>
//         </div>
//       ))}

//       {editingArticle && (
//         <div className={css.editSection}>
//           <h3>Редагування статті</h3>

//           {objList.map((field) => (
//             <div key={field.transliter} className={css.wrapSmallList}>
//               <p className={css.paramBooks}>{field.name}</p>
//               <input
//                 type="text"
//                 value={editingArticle[field.transliter] || ""}
//                 onChange={(e) => handleChange(field.transliter, e.target.value)}
//               />
//             </div>
//           ))}

//           <div className={css.wrapSmallList}>
//             <p className={css.paramBooks}>Третій (довгий опис)</p>
//             <ReactQuill
//               value={editingArticle.longDesc || ""}
//               onChange={(value) => handleChange("longDesc", value)}
//               className={css.quillEditornewBlog}
//               modules={{
//                 toolbar: [
//                   [{ header: [1, 2, 3, false] }],
//                   ["bold", "italic", "underline", "strike", "link"],
//                   [{ list: "ordered" }, { list: "bullet" }],
//                   [{ align: [] }],
//                   ["clean"],
//                 ],
//               }}
//               formats={[
//                 "header",
//                 "bold",
//                 "italic",
//                 "underline",
//                 "strike",
//                 "link",
//                 "list",
//                 "bullet",
//                 "align",
//               ]}
//             />
//           </div>

//           <div className={css.wrapSmallList}>
//             <p className={css.paramBooks}>Фото</p>
//             {editingArticle.photo && (
//               <div style={{ marginBottom: "8px" }}>
//                 <a
//                   href={editingArticle.photo}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   Переглянути поточне фото
//                 </a>
//               </div>
//             )}
//             <input type="file" onChange={handleFileChange} />
//           </div>

//           <div className={css.wrapSmallList}>
//             <label className={css.paramBooks}>
//               <input
//                 type="checkbox"
//                 checked={!!editingArticle.check}
//                 onChange={(e) => handleChange("check", e.target.checked)}
//               />
//               &nbsp;Посилання на сторонній сайт
//             </label>
//           </div>

//           {editingArticle.check && (
//             <div className={css.wrapSmallList}>
//               <p className={css.paramBooks}>Посилання</p>
//               <input
//                 type="text"
//                 value={editingArticle.linkto || ""}
//                 onChange={(e) => handleChange("linkto", e.target.value)}
//               />
//             </div>
//           )}

//           <button onClick={handleSave} className={css.addBookButtonBlog}>
//             Зберегти
//           </button>
//           <button onClick={() => setEditingArticle(null)}>Скасувати</button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default BlogListEditor;
import { useEffect, useState } from "react";
import {
  getDocs,
  collection,
  updateDoc,
  doc,
  deleteDoc,
  serverTimestamp,
} from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { db } from "../../firebase";
import css from "./blogeditor.module.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  createBlogSlug,
  normalizeBlogSlug,
  getBlogSlug,
  getUniqueBlogSlug,
} from "../../function/blogSlug";
const BlogListEditor = () => {
  const [articles, setArticles] = useState([]);
  const [editingArticle, setEditingArticle] = useState(null);
  const [newPhotoFile, setNewPhotoFile] = useState(null);
  const [sortOrder, setSortOrder] = useState("newest");
  const objList = [
    { name: "Заголовок", transliter: "zag", large: true },
    {
      name: "ЧПУ URL",
      transliter: "slug",
      large: false,
    },
    { name: "Перший опис", transliter: "chortDesc", large: true },
    { name: "SEO title", transliter: "seoTitle", large: true },
    { name: "SEO description", transliter: "seoDescription", large: true },
    { name: "ID відео", transliter: "videoId", large: false },
  ];
  const getArticleDateValue = (article) => {
    const date =
      article.timestamp ||
      article.createdAt ||
      article.createdDate ||
      article.date ||
      article.updatedAt;

    if (!date) return 0;

    if (date?.toDate) {
      return date.toDate().getTime();
    }

    return new Date(date).getTime() || 0;
  };

  const fetchArticles = async () => {
    try {
      const snapshot = await getDocs(collection(db, "blog"));

      const docs = snapshot.docs.map((docItem) => ({
        id: docItem.id,
        ...docItem.data(),
      }));

      setArticles(docs);
    } catch (error) {
      console.error("Помилка при отриманні статей:", error);
    }
  };

  useEffect(() => {
    fetchArticles();
  }, []);

  const handleEdit = (article) => {
    setEditingArticle({ ...article });
    setNewPhotoFile(null);
  };

  const handleChange = (field, value) => {
    setEditingArticle((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleFileChange = (e) => {
    setNewPhotoFile(e.target.files[0] || null);
  };

  const handleCancel = () => {
    setEditingArticle(null);
    setNewPhotoFile(null);
  };

  const handleSave = async () => {
    if (!editingArticle) {
      return;
    }

    try {
      const articleTitle = String(editingArticle.zag || "").trim();

      if (!articleTitle) {
        window.alert("Заголовок статті не може бути порожнім.");

        return;
      }

      /*
       * Значення, введене адміністратором.
       */
      const enteredSlug = String(editingArticle.slug || "").trim();

      /*
       * Нормалізоване ручне ЧПУ.
       */
      const manualSlug = normalizeBlogSlug(enteredSlug);

      /*
       * Автоматичне ЧПУ із заголовка.
       */
      const generatedSlug = createBlogSlug(articleTitle);

      if (enteredSlug && !manualSlug) {
        window.alert(
          "Введено некоректне ЧПУ. Використовуйте слова, цифри та дефіси.",
        );

        return;
      }

      if (!manualSlug && !generatedSlug) {
        window.alert("Не вдалося сформувати ЧПУ із заголовка.");

        return;
      }

      /*
       * Беремо всі статті, крім тієї,
       * яку зараз редагуємо.
       *
       * Інакше поточне ЧПУ конфліктувало б саме із собою.
       */
      const usedSlugs = new Set(
        articles
          .filter((article) => {
            return article.id !== editingArticle.id;
          })
          .map((article) => {
            return getBlogSlug(article);
          })
          .filter(Boolean),
      );

      let finalSlug = "";

      if (manualSlug) {
        /*
         * Ручне ЧПУ не змінюємо автоматично.
         * Якщо воно зайняте — показуємо помилку.
         */
        if (usedSlugs.has(manualSlug)) {
          window.alert(
            `ЧПУ "${manualSlug}" уже використовується іншою статтею.`,
          );

          return;
        }

        finalSlug = manualSlug;
      } else {
        /*
         * Якщо поле очищене,
         * створюємо нове ЧПУ із заголовка.
         */
        finalSlug = getUniqueBlogSlug(generatedSlug, usedSlugs);
      }

      /*
       * Знаходимо початкову версію статті
       * у списку до редагування.
       */
      const originalArticle = articles.find((article) => {
        return article.id === editingArticle.id;
      });

      /*
       * Отримуємо попереднє ЧПУ.
       *
       * Для старої статті без slug воно
       * буде створене із заголовка.
       */
      const previousSlug = originalArticle ? getBlogSlug(originalArticle) : "";

      /*
       * Беремо список старих URL,
       * якщо він уже існує.
       */
      const previousSlugs = Array.isArray(editingArticle.oldSlugs)
        ? editingArticle.oldSlugs
            .map((slugItem) => {
              return normalizeBlogSlug(slugItem);
            })
            .filter(Boolean)
        : [];

      /*
       * Якщо ЧПУ змінилося,
       * стару адресу додаємо до oldSlugs.
       */
      if (previousSlug && previousSlug !== finalSlug) {
        previousSlugs.push(previousSlug);
      }

      /*
       * Прибираємо дублікати.
       * Поточне ЧПУ не повинно бути в oldSlugs.
       */
      const uniqueOldSlugs = [...new Set(previousSlugs)].filter((slugItem) => {
        return slugItem !== finalSlug;
      });

      /*
       * Firestore document id не записуємо
       * всередину документа.
       */
      const { id, ...articleData } = editingArticle;

      let updatedArticle = {
        ...articleData,
        zag: articleTitle,
        slug: finalSlug,
        oldSlugs: uniqueOldSlugs,
        updatedAt: serverTimestamp(),
      };

      /*
       * Ваша поточна обробка відступів.
       */
      if (updatedArticle.longDesc) {
        updatedArticle.longDesc = updatedArticle.longDesc.replace(
          /<p><br><\/p>/g,
          '<div class="spacer"></div>',
        );
      }

      /*
       * Якщо вибрано нове фото —
       * завантажуємо його.
       */
      if (newPhotoFile) {
        const storage = getStorage();

        const storageRef = ref(
          storage,
          `blog/${editingArticle.id}/${newPhotoFile.name}`,
        );

        await uploadBytes(storageRef, newPhotoFile);

        const downloadURL = await getDownloadURL(storageRef);

        updatedArticle.photo = downloadURL;
      }

      const refDoc = doc(db, "blog", editingArticle.id);

      await updateDoc(refDoc, updatedArticle);

      window.alert(`Статтю збережено.\nURL: /blog/${finalSlug}`);

      setEditingArticle(null);
      setNewPhotoFile(null);

      await fetchArticles();
    } catch (error) {
      console.error("Помилка при оновленні статті:", error);

      window.alert("Не вдалося оновити статтю. Перевірте консоль.");
    }
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Ви впевнені, що хочете видалити цю статтю?",
    );

    if (!confirmDelete) return;

    try {
      await deleteDoc(doc(db, "blog", id));
      fetchArticles();
    } catch (error) {
      console.error("Помилка при видаленні статті:", error);
    }
  };
  const sortedArticles = [...articles].sort((a, b) => {
    const dateA = getArticleDateValue(a);
    const dateB = getArticleDateValue(b);

    if (sortOrder === "oldest") {
      return dateA - dateB;
    }

    return dateB - dateA;
  });
  return (
    <div className={css.divForList}>
      <h2>Редактор блогу</h2>
      <div className={css.sortWrap}>
        <label className={css.sortLabel}>
          Сортування:
          <select
            className={css.sortSelect}
            value={sortOrder}
            onChange={(e) => setSortOrder(e.target.value)}
          >
            <option value="newest">Від найновіших</option>
            <option value="oldest">Від найстаріших</option>
          </select>
        </label>
      </div>
      <div className={css.articlesListWrap}>
        {sortedArticles.map((article) => (
          <div key={article.id} className={css.listLiProd}>
            <p className={css.articleTitleInList}>
              <strong>{article.zag}</strong>
            </p>

            <div className={css.articleButtonsWrap}>
              <button
                type="button"
                className={css.editBlogButton}
                onClick={() => handleEdit(article)}
              >
                Редагувати
              </button>

              <button
                type="button"
                className={css.deleteBlogButton}
                onClick={() => handleDelete(article.id)}
              >
                Видалити
              </button>
            </div>
          </div>
        ))}
      </div>

      {editingArticle && (
        <div className={css.editSection}>
          <h3>Редагування статті</h3>

          {objList.map((field) => (
            <div key={field.transliter} className={css.wrapSmallList}>
              <p className={css.paramBooks}>{field.name}</p>

              {field.large ? (
                <textarea
                  name={field.transliter}
                  className={css.blogTextAreaField}
                  value={editingArticle[field.transliter] || ""}
                  onChange={(e) =>
                    handleChange(field.transliter, e.target.value)
                  }
                />
              ) : (
                <input
                  name={field.transliter}
                  type="text"
                  className={css.blogInputField}
                  value={editingArticle[field.transliter] || ""}
                  placeholder={
                    field.transliter === "slug"
                      ? createBlogSlug(editingArticle.zag)
                      : ""
                  }
                  onChange={(e) => {
                    handleChange(field.transliter, e.target.value);
                  }}
                  onBlur={(e) => {
                    /*
                     * Після виходу з поля ЧПУ
                     * очищаємо введений URL.
                     */
                    if (field.transliter === "slug" && e.target.value.trim()) {
                      handleChange("slug", normalizeBlogSlug(e.target.value));
                    }
                  }}
                />
              )}
            </div>
          ))}

          <div className={css.wrapSmallList}>
            <p className={css.paramBooks}>Третій (довгий опис)</p>

            <ReactQuill
              value={editingArticle.longDesc || ""}
              onChange={(value) => handleChange("longDesc", value)}
              className={css.quillEditornewBlog}
              modules={{
                toolbar: [
                  [{ header: [1, 2, 3, false] }],
                  ["bold", "italic", "underline", "strike", "link"],
                  [{ list: "ordered" }, { list: "bullet" }],
                  [{ align: [] }],
                  ["clean"],
                ],
              }}
              formats={[
                "header",
                "bold",
                "italic",
                "underline",
                "strike",
                "link",
                "list",
                "bullet",
                "align",
              ]}
            />
          </div>

          <div className={css.wrapSmallList}>
            <p className={css.paramBooks}>Фото</p>

            {editingArticle.photo && (
              <div className={css.currentPhotoLinkWrap}>
                <a
                  href={editingArticle.photo}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Переглянути поточне фото
                </a>
              </div>
            )}

            <input type="file" onChange={handleFileChange} />
          </div>

          <div className={css.wrapSmallList}>
            <label className={css.checkboxLabel}>
              <input
                type="checkbox"
                checked={!!editingArticle.check}
                onChange={(e) => handleChange("check", e.target.checked)}
              />
              &nbsp;Посилання на сторонній сайт
            </label>
          </div>

          {editingArticle.check && (
            <div className={css.wrapSmallList}>
              <p className={css.paramBooks}>Посилання</p>

              <input
                type="text"
                className={css.blogInputField}
                value={editingArticle.linkto || ""}
                onChange={(e) => handleChange("linkto", e.target.value)}
              />
            </div>
          )}

          <div className={css.editActionsWrap}>
            <button
              type="button"
              onClick={handleSave}
              className={css.addBookButtonBlog}
            >
              Зберегти
            </button>

            <button
              type="button"
              onClick={handleCancel}
              className={css.cancelBlogButton}
            >
              Скасувати
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default BlogListEditor;
